<div class="decision-tree-container">

  <!-- Top Nav Bar -->
  <div class="dt-nav-bar">
    <span class="dt-nav-title">Decision Tree</span>
    <div class="dt-nav-actions">
      <button class="dt-nav-btn" (click)="createNewTree()" title="Create a new starter tree">
        <span class="dt-nav-btn-icon">+</span> Create
      </button>
      <button
        class="dt-nav-btn dt-nav-btn--save"
        (click)="saveTreeToDb()"
        [disabled]="isSaving"
        [title]="isSaving ? 'Saving…' : 'Save tree to database'">
        {{ isSaving ? 'Saving…' : '&#128190; Save' }}
      </button>
      <button class="dt-nav-btn" (click)="autoArrange()" title="Auto-arrange the tree layout">
        &#8633; Auto Arrange
      </button>
      <button class="dt-nav-btn" (click)="exportAsSfe()" title="Export as .sfe file">
        &#8595; Export As SFE
      </button>
    </div>
    <span class="dt-nav-tree-name" [class.dt-nav-tree-name--unsaved]="hasUnsavedChanges">
      {{ currentTreeName }}{{ hasUnsavedChanges ? ' *' : '' }}
    </span>
  </div>

  <!-- Unsaved-changes confirmation notification (top-left) -->
  @if (unsavedConfirmVisible) {
    <div class="dt-unsaved-confirm" role="alertdialog" aria-live="assertive">
      <div class="dt-uc-icon">&#9888;</div>
      <div class="dt-uc-body">
        <p class="dt-uc-title">Unsaved changes</p>
        <p class="dt-uc-message">The current tree has unsaved changes. Do you want to discard them and create a new tree?</p>
        <div class="dt-uc-actions">
          <button class="dt-uc-btn dt-uc-btn--save" [disabled]="isSaving" (click)="saveAndCreate()">{{ isSaving ? 'Saving…' : '💾 Save' }}</button>
          <button class="dt-uc-btn dt-uc-btn--danger" (click)="confirmDiscardAndCreate()">Discard &amp; Create</button>
          <button class="dt-uc-btn dt-uc-btn--cancel" (click)="dismissUnsavedConfirm()">Cancel</button>
        </div>
      </div>
    </div>
  }

  @if (dataModel) {
    <ng-diagram
      [model]="dataModel"
      [config]="config"
      [nodeTemplateMap]="nodeTemplateMap"
      (selectionChanged)="onSelectionChanged($event)">
      <ng-diagram-background />
    </ng-diagram>
  }

  <!-- Edge Rename Popup -->
  @if (edgeContextMenu.visible) {
    <div
      class="dt-context-menu dt-edge-context-menu"
      [style.left.px]="edgeContextMenu.x"
      [style.top.px]="edgeContextMenu.y"
      (click)="$event.stopPropagation()">

      <div class="dt-cm-header">
        <span class="dt-cm-title">Edge</span>
        <button class="dt-cm-close" (click)="closeEdgeContextMenu()" title="Close">&times;</button>
      </div>

      <div class="dt-cm-section">
        <label class="dt-cm-label">Edge Text</label>
        <div class="dt-cm-row">
          <input
            class="dt-cm-input"
            [(ngModel)]="edgeLabelText"
            placeholder="Edge label"
            (keydown.enter)="applyEdgeEdit()" />
          <button class="dt-cm-btn dt-cm-btn--primary" (click)="applyEdgeEdit()">Apply</button>
        </div>
      </div>
    </div>
  }

  <!-- Context Menu Popup -->
  @if (contextMenu.visible) {
    <div
      class="dt-context-menu"
      [style.left.px]="contextMenu.x"
      [style.top.px]="contextMenu.y"
      (click)="$event.stopPropagation()">

      <div class="dt-cm-header">
        <span class="dt-cm-title">Node</span>
        <button class="dt-cm-close" (click)="closeContextMenu()" title="Close">&times;</button>
      </div>

      <div class="dt-cm-section">
        <label class="dt-cm-label">Node Text</label>
        <div class="dt-cm-row">
          <input
            class="dt-cm-input"
            [(ngModel)]="editText"
            placeholder="Node label"
            (keydown.enter)="applyEdit()" />
          <button class="dt-cm-btn dt-cm-btn--primary" (click)="applyEdit()">Apply</button>
        </div>
      </div>

      <div class="dt-cm-section dt-cm-actions">
        <button
          class="dt-cm-btn dt-cm-btn--success"
          (click)="addChildNode()">
          + Add Child
        </button>
        <button
          class="dt-cm-btn dt-cm-btn--success"
          (click)="addNodeWithLeaf()">
          + Add Node
        </button>
        <button
          class="dt-cm-btn dt-cm-btn--success"
          (click)="addLeafNode()">
          + Add Leaf
        </button>
        <button
          class="dt-cm-btn dt-cm-btn--danger"
          [disabled]="contextMenu.isRoot"
          [title]="contextMenu.isRoot ? 'Root node cannot be removed' : 'Remove node and subtree'"
          (click)="removeNode()">
          Remove
        </button>
        @if (contextMenu.hasChildren) {
          <button
            class="dt-cm-btn dt-cm-btn--secondary"
            (click)="toggleCollapse()">
            {{ isSelectedNodeCollapsed ? 'Expand' : 'Hide' }}
          </button>
        }
        @if (!contextMenu.isRoot && !contextMenu.isLeaf) {
          <button
            class="dt-cm-btn dt-cm-btn--secondary"
            title="Copy this branch and its subtree"
            (click)="copyBranch()">
            Copy
          </button>
        }
        @if (!contextMenu.isLeaf) {
          <button
            class="dt-cm-btn dt-cm-btn--secondary"
            [disabled]="!canPaste"
            [title]="!hasCopiedBranch ? 'No branch copied yet'
                     : !canPaste      ? 'Cannot paste a branch with the same name'
                     : 'Paste copied branch as a child of this node'"
            (click)="pasteBranch()">
            Paste
          </button>
        }
      </div>

      <div class="dt-cm-divider"></div>

      <!-- <div class="dt-cm-section dt-cm-actions">
        <button class="dt-cm-btn dt-cm-btn--outline" (click)="saveTree()">Save</button>
        <button class="dt-cm-btn dt-cm-btn--outline" (click)="saveAs()">Save As</button>
        <button class="dt-cm-btn dt-cm-btn--outline" (click)="printSvg()">Print</button>
      </div> -->
    </div>
  }
</div>
